const LOGIN_STORE = {
    retry_count: 0,
    doing: false,
    req_queue: [],

    start () {
        LOGIN_STORE.doing = true
    },
    wait (res) {
        LOGIN_STORE.req_queue.push(res)
    },
    finish () {
        LOGIN_STORE.doing = false
        LOGIN_STORE.retry_count = 0
        while (LOGIN_STORE.req_queue && LOGIN_STORE.req_queue.length) {
            LOGIN_STORE.req_queue.shift()()
        }
    },
    fail () {
        const can_retry = LOGIN_STORE.retry_count < 5
        if (can_retry) {
            LOGIN_STORE.retry_count++
        } else {
            LOGIN_STORE.retry_count = 0
        }
        return can_retry
    }
}

const MAX_401_COUNT = 3
const RESET_401_DELAY = 30000

const RELOGIN_401 = {
    retry_count: 0,
    reset ()  {
        RELOGIN_401.retry_count = 0
    },
    add () {
        if (!LOGIN_STORE.doing) {
            RELOGIN_401.retry_count++
        }
    },
    check () {
        return RELOGIN_401.retry_count <= MAX_401_COUNT
    },
    reachLimit () {
        setTimeout(RELOGIN_401.reset, RESET_401_DELAY)
    }
}

module.exports = {
    LOGIN_STORE,
    RELOGIN_401

}